import ResponsiveDirectusImage from '../ResponsiveImage.jsx';

const CoverImage = ({ image }) => {
  return <ResponsiveDirectusImage assetLandscape={image.asset_landscape} assetPortrait={image.asset_portrait} />
};

export default CoverImage;
